import { $api } from "@/lib/api-client";

export type UseFetchMeReturn = ReturnType<typeof useFetchMe>;

export function useFetchMe() {
  // Short on purpose. The protected layout hydrates this key with what the
  // server already fetched; with the client's default staleTime of 0 that data
  // is stale on arrival and refetched immediately, which defeats the point.
  // 30s is long enough to swallow the duplicate on page load and rapid
  // navigation, short enough that nothing feels stuck.
  //
  // Freshness does NOT rely on this window — it comes from explicit
  // invalidation on the events that change the user (purchase, profile edit,
  // login, placement sync). Never raise this to something long or infinite.
  const result = $api.useQuery("get", "/user/me", {}, { staleTime: 30_000 });

  return {
    ...result,
    data: result.data?.data,
  };
}
